module.exports = __webpack_public_path__ + "static/media/connect-background.1af46413.png";